import React from 'react';
import { Link } from 'react-router-dom';
import { AlertOctagon, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { useUsage } from '../hooks/useUsage';

// Phase 10 — shown on Dashboard (above forms list) when the user's paid
// subscription has expired. Read-only mode: they can still view but not
// create new forms.
export const ExpiredPlanBanner = () => {
  const { usage } = useUsage();
  if (!usage?.subscription?.is_expired) return null;

  const expDate = usage.subscription.expires_at
    ? new Date(usage.subscription.expires_at).toLocaleDateString()
    : null;

  return (
    <div
      data-testid="expired-plan-banner"
      className="rounded-xl border-2 border-rose-200 bg-rose-50 p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4"
    >
      <div className="shrink-0 w-10 h-10 rounded-lg bg-rose-100 flex items-center justify-center">
        <AlertOctagon className="w-5 h-5 text-rose-600" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-bold text-rose-900 leading-tight">
          Your {usage.plan_display_name} subscription has expired{expDate ? ` on ${expDate}` : ''}.
        </p>
        <p className="text-xs text-rose-800/80 mt-0.5">
          You can still view existing forms and download submissions, but new forms and submissions are paused.
          Apply a new voucher or upgrade to keep collecting submissions.
        </p>
      </div>
      <Link to="/billing">
        <Button
          size="sm"
          data-testid="expired-plan-banner-cta"
          className="bg-rose-600 hover:bg-rose-700 text-white font-semibold"
        >
          Go to Billing
          <ArrowRight className="w-3.5 h-3.5 ml-1.5" />
        </Button>
      </Link>
    </div>
  );
};
